<template>
  <div class="row">
    <ul v-if="pageCount > 1 && pageCount <= 4" class="pagination">
      <li :class="{disabled: currentPage === 1}">
        <a @click="goToFirstPage">
          <span class="glyphicon glyphicon-fast-backward"></span>
        </a>
      </li>
      <li v-for="i in pageCount" :key="i" :class="{active: i === currentPage}">
        <a @click="$emit('select-page', i)">{{ i }}</a>
      </li>
      <li :class="{disabled: currentPage === pageCount}">
        <a @click="goToLastPage">
          <span class="glyphicon glyphicon-fast-forward"></span>
        </a>
      </li>
    </ul>

    <ul v-else-if="pageCount > 4" class="pagination">
      <li :class="{disabled: currentPage === 1}">
        <a @click="goToFirstPage">
          <span class="glyphicon glyphicon-fast-backward"></span>
        </a>
      </li>
      <li :class="{disabled: currentPage === 1}">
        <a @click="goBack">
          <span class="glyphicon glyphicon-step-backward"></span>
        </a>
      </li>
      <li :class="{active: currentPage === Math.max(currentPage - 2, 1)}">
        <a @click="$emit('select-page', Math.max(currentPage - 2, 1))">
          {{ Math.max(currentPage - 2, 1) }}
        </a>
      </li>
      <li :class="{active: currentPage === Math.max(currentPage - 1, 2)}">
        <a @click="$emit('select-page', Math.max(currentPage - 1, 2))">
          {{ Math.max(currentPage - 1, 2) }}
        </a>
      </li>
      <li
        v-if="currentPage < pageCount"
        :class="{active: currentPage === Math.max(currentPage, 3)}"
      >
        <a @click="$emit('select-page', Math.max(currentPage, 3))">
          {{ Math.max(currentPage, 3) }}
        </a>
      </li>
      <li><a @click="openModal">...</a></li>
      <li :class="{active: currentPage === pageCount}">
        <a @click="$emit('select-page', pageCount)">{{ pageCount }}</a>
      </li>
      <li :class="{disabled: currentPage === pageCount}">
        <a @click="goForward">
          <span class="glyphicon glyphicon-step-forward"></span>
        </a>
      </li>
      <li :class="{disabled: currentPage === pageCount}">
        <a @click="goToLastPage">
          <span class="glyphicon glyphicon-fast-forward"></span>
        </a>
      </li>
    </ul>

    <sweet-modal
      ref="modal"
      hide-close-button
      class="extra-pagination vld-parent"
    >
      <p>
        <strong>{{ $t('modals.select_page') }}</strong>
        <v-select
          :options="pages"
          v-model="jumpPage"
          :taggable="false"
          :filterable="true"
        />
      </p>
      <template #button>
        <button class="btn btn-primary" @click="jump">
          {{ $t('modals.jump_page') }}
        </button>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue-3';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'PaginationComponent',
  components: {
    SweetModal,
    'v-select': vSelect
  },
  props: {
    pageCount: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      jumpPage: 0
    };
  },
  computed: {
    pages() {
      return Array.from({length: this.pageCount}, (_, i) => i + 1);
    }
  },
  methods: {
    openModal() {
      this.jumpPage = Math.min(
        Math.max(this.currentPage + 1, 4),
        this.pageCount - 1
      );
      this.$refs.modal.open();
    },
    jump() {
      if (this.jumpPage >= 1 && this.jumpPage <= this.pageCount) {
        this.$refs.modal.close();
        this.$emit('select-page', this.jumpPage);
      }
    },
    goToFirstPage() {
      if (this.currentPage > 1) {
        this.$emit('select-page', 1);
      }
    },
    goBack() {
      if (this.currentPage > 1) {
        this.$emit('select-page', this.currentPage - 1);
      }
    },
    goToLastPage() {
      if (this.currentPage < this.pageCount) {
        this.$emit('select-page', this.pageCount);
      }
    },
    goForward() {
      if (this.currentPage < this.pageCount) {
        this.$emit('select-page', this.currentPage + 1);
      }
    }
  }
};
</script>

<style scoped>
.pagination li {
  cursor: pointer;
}
.extra-pagination .v-select {
  width: 100%;
}
</style>
